// @need-translate
import {useCallback} from 'react';
import {twMerge} from '../../common/twMerge';
import useTypedDispatch from '../../common/useTypedDispatch';
import useTypedSelector from '../../common/useTypedSelector';
import {ViewerType} from '../../domain/content/[seriesId]/viewer/[productId]/constant/viewerConstant';
import {changeReadType as changeTextReadType} from '../../domain/content/[seriesId]/viewer/[productId]/state/textViewerSlice';
import {setCurrentViewerGuide} from '../../domain/content/[seriesId]/viewer/[productId]/state/viewerInfoSlice';
import {TextViewerReadType} from '../../domain/content/[seriesId]/viewer/[productId]/type/TextViewerReadType';
import {convertViewerReadTypeToGuideType} from '../../domain/content/[seriesId]/viewer/[productId]/util/convertViewerReadTypeToGuideType';
import {showViewerGuide} from '../../domain/content/[seriesId]/viewer/[productId]/util/showViewerGuide';
import {SlideType} from '../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../reactQuery/constant';
import {useViewerInfoQuery} from '../../wrapper/viewerWrapper';
import {PcViewerHeader} from '../organisms/PcViewerHeader/PcViewerHeader';

export function PcLayoutTextViewerPreviewHeader({
  seriesId,
  productId,
}: {
  seriesId: number;
  productId: number;
}) {
  const dispatch = useTypedDispatch();

  const {data, isError} = useViewerInfoQuery(
    {
      seriesId,
      productId,
    },
    ONLY_DATA_CONFIG
  );

  const viewerData = data;

  const {isViewerMenuExposed} = useTypedSelector(state => ({
    isViewerMenuExposed: state.viewerMenu.isExposed,
  }));

  const {textViewerSettings} = useTypedSelector(state => ({
    textViewerSettings: state.textViewer.settings,
  }));

  const checkPcIsScrollView = useCallback(() => {
    if (!viewerData) return false;
    return textViewerSettings.readType === TextViewerReadType.Scroll;
  }, [textViewerSettings.readType, viewerData]);

  const onClickViewTypeButton = useCallback(() => {
    if (!viewerData) return false;

    if (viewerData.item.slideType === SlideType.Epub) {
      const changedReadType =
        textViewerSettings.readType === TextViewerReadType.Page
          ? TextViewerReadType.Scroll
          : TextViewerReadType.Page;
      dispatch(changeTextReadType(changedReadType));
      dispatch(
        setCurrentViewerGuide(
          convertViewerReadTypeToGuideType({
            viewerType: ViewerType.TextViewer,
            viewerReadType: changedReadType,
          })
        )
      );
      showViewerGuide({
        viewerGuideType: convertViewerReadTypeToGuideType({
          viewerType: ViewerType.TextViewer,
          viewerReadType: changedReadType,
        }),
      });
    }
  }, [dispatch, textViewerSettings.readType, viewerData]);

  const showNotSupportAlert = useCallback(() => {
    window.alert('지원하지 않습니다.');
  }, []);

  if (isError || !viewerData) {
    return (
      <PcViewerHeader
        title="미리보기"
        hasNavMenu={false}
        showAgeGradeLabel={false}
      />
    );
  }
  return (
    <>
      <div className={twMerge('w-1200pxr', !isViewerMenuExposed && 'hidden')}>
        <PcViewerHeader
          title={viewerData.item.title}
          hasNavMenu={true}
          hasViewTypeButton={true}
          showAgeGradeLabel={false}
          isScrollView={checkPcIsScrollView()}
          onClickViewTypeButton={onClickViewTypeButton}
          onClickNonStopWatchingButton={showNotSupportAlert}
          onClickCommentButton={showNotSupportAlert}
          onClickContentsHomeButton={showNotSupportAlert}
        />
      </div>
    </>
  );
}
